// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3zrES","col":"Table_col__2k8P_","fulfillmentStatus":"Table_fulfillmentStatus__2ATWM","emailCol":"Table_emailCol__2d6hF"};